import { configureStore } from "@reduxjs/toolkit";
import informationReducer from "./informationSlice";
import authReducer from "./authSlice";
import settingReducer from "./settingSlice";
import accountReducer from "./accountSlice";
import wsReducer from "./wsSlice";
const store = configureStore({
  reducer: {
    auth: authReducer,
    information: informationReducer,
    ws: wsReducer,
    setting: settingReducer,
    account: accountReducer,
  },
});

export default store;
